module.exports = __webpack_public_path__ + "static/media/howzu-logo-default.99809353.png";